import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getCalendarEventTagsQuery,
  getCalendarEventsQuery,
  getOrganizationRotationDaysQuery,
} from "./CalendarQuery";

export const getCalendarEventTagsFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCalendarEventTagsQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeCalendarEventTagsToCache = ({ id, data }) => {
  try {
    client.writeQuery({
      query: getCalendarEventTagsQuery,
      variables: {
        id,
      },
      data: { node: data },
    });
  } catch (e) {}
};

export const getCalendarEventsFromCache = ({
  rangeBeginStartDate,
  rangeEndStartDate,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCalendarEventsQuery,
      variables: {
        rangeBeginStartDate,
        rangeEndStartDate,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "school", {});
  else return {};
};

export const getOrganizationRotationDaysFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationRotationDaysQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
